import { Assignment } from '@shared/integrations/taf-api/v2/models';
import { formatDate } from '@shared/utils/dateUtils';


interface IAssignmentCardProps {
    assignment: Assignment;
}

const AssignmentCard = ({ assignment }: IAssignmentCardProps) => {
    return (
        <div className='card card-body mb-4'>
            <h4>Mitt förtroendeuppdrag</h4>
            <div className='ft-table ft-responsive-sm table-mark-empty mb-0 font-size-sm'>
                <div className='ft-tr'>
                    <div className='ft-th'>Uppdrag</div>
                    <div className='ft-td highlight-mask'>{assignment.roleName}</div>
                </div>
                {/*<div className='ft-tr'>*/}
                {/*    <div className='ft-th highlight-mask'>Partstyp</div>*/}
                {/*    <div className='ft-td'>{assignment.organizationName}</div>*/}
                {/*</div>*/}
                {assignment.startDate && (
                    <div className='ft-tr'>
                        <div className='ft-th'>Startdatum</div>
                        <div className='ft-td'>{formatDate(assignment.startDate)}</div>
                    </div>
                )}
                {assignment.endDate && (
                    <div className='ft-tr'>
                        <div className='ft-th'>Slutdatum</div>
                        <div className='ft-td'>{formatDate(assignment.endDate)}</div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AssignmentCard;
